import { api } from '@/utils/api';
import type {
	SensorDevice,
	SensorDeviceDTO,
	SensorMaintenanceLensService,
	SensorMaintenanceResume,
	SensorMaintenanceResumeDTO,
	SensorMaintenanceResumeParams,
} from '../types/sensorMaintenanceLens.types';
import { mapSensorDevices, mapSensorMaintenanceResume } from './sensorMaintenanceLensMappers';

const BASE_PATH = 'sensor-maintenance-lens';

export const httpSensorMaintenanceLensService: SensorMaintenanceLensService = {
	async getResume(params: SensorMaintenanceResumeParams): Promise<SensorMaintenanceResume> {
		const response = await api.get<SensorMaintenanceResumeDTO>(
			`${BASE_PATH}/locations/${encodeURIComponent(params.locationId)}/summary`,
		);
		return mapSensorMaintenanceResume(response.data);
	},

	async getDevices(locationId: string): Promise<SensorDevice[]> {
		const response = await api.get<SensorDeviceDTO[]>(
			`${BASE_PATH}/locations/${encodeURIComponent(locationId)}/devices`,
		);
		return mapSensorDevices(response.data);
	},
};
